import React, { Component } from 'react';
import {
  Modal,
  Button,
  Row,
  Col,
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
  Table
} from 'react-bootstrap';

class QuarterlyModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      date: '',
      previewData: null,
      isLoading: false,
      step: 'form'
    };
  }

  onFetchPreview = (e) => {
    e.preventDefault();
    if (!this.state.date) return;
    this.setState({ isLoading: true });
    this.props.onPreviewQuarterly({
      date: this.state.date,
      activePortfolioId: this.props.activePortfolioId
    })
      .then((res) => {
        this.setState({
          previewData: res.data,
          isLoading: false,
          step: 'preview'
        });
      })
      .catch(() => {
        this.setState({ isLoading: false });
      });
  }

  onConfirmUpdate = () => {
    this.props.onQuarterly({
      date: this.state.date,
      activePortfolioId: this.props.activePortfolioId,
      previewData: this.state.previewData
    });
    this.closeModal();
  }

  onBack = () => {
    this.setState({ step: 'form', previewData: null });
  }

  closeModal = () => {
    this.props.closeModal('showQuarterlyModal');
    this.setState({ date: '', previewData: null, step: 'form' });
  }

  renderPreviewTable() {
    const { previewData } = this.state;
    if (!previewData) return null;

    const allRows = [];
    if (previewData.tickers) {
      previewData.tickers.forEach(item => {
        allRows.push({ type: 'Ticker', symbol: item.symbol, quarterly: item.quarterly });
      });
    }
    if (previewData.benchmarks) {
      previewData.benchmarks.forEach(item => {
        allRows.push({ type: 'Benchmark', symbol: item.symbol, quarterly: item.quarterly });
      });
    }
    if (previewData.sectors) {
      previewData.sectors.forEach(item => {
        allRows.push({ type: 'Sector', symbol: item.symbol, quarterly: item.quarterly });
      });
    }

    return (
      <Table striped bordered condensed hover>
        <thead>
          <tr>
            <th>Type</th>
            <th>Symbol</th>
            <th>Quarterly Price</th>
          </tr>
        </thead>
        <tbody>
          {allRows.map((row, idx) => (
            <tr key={`${row.type}-${row.symbol}-${idx}`}>
              <td>{row.type}</td>
              <td>{row.symbol}</td>
              <td>{row.quarterly}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  }

  render() {
    const { showQuarterlyModal } = this.props;
    const { step, isLoading } = this.state;

    return (
      <Modal show={showQuarterlyModal} onHide={this.closeModal} className="toolbar-modal">
        <Modal.Header closeButton>
          <Modal.Title>Update Quarterly</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {step === 'form' && (
            <Row>
              <Col mdOffset={2} md={8}>
                <Form onSubmit={(e) => this.onFetchPreview(e)}>
                  <FormGroup controlId="amount">
                    <ControlLabel>Enter Date (yyyy-mm-dd):</ControlLabel>
                    <FormControl
                      type="date"
                      placeholder=""
                      value={this.state.date}
                      name="date"
                      required
                      onChange={(e) => {
                        this.setState({ [e.target.name]: e.target.value });
                        // console.log(e.target.value);
                      }} />
                  </FormGroup>
                  <p>*Please ensure the date is the last trading day of the quarter. E.g. 29-12-2017</p>
                  <p>**Updating quarterly will override all existing quarterly values!</p>
                  <Button
                    className="submit-right btn-red"
                    bsStyle="danger"
                    type="submit"
                    disabled={isLoading}
                  >
                    {isLoading ? 'Fetching...' : 'Fetch Preview'}
                  </Button>
                </Form>
              </Col>
            </Row>
          )}
          {step === 'preview' && (
            <div>
              <p>Review the quarterly data below. Click OK to save to database.</p>
              {this.renderPreviewTable()}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {step === 'form' ? (
            <Button bsStyle="default" onClick={this.closeModal}>Close</Button>
          ) : (
            <>
              <Button bsStyle="default" onClick={this.onBack}>Cancel</Button>
              <Button bsStyle="primary" onClick={this.onConfirmUpdate}>Update</Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

export default QuarterlyModal;
